import React, { useEffect, useMemo, useRef, useState } from 'react';

const GeneroSelector = (props) => {
  const containerRef = useRef(null);
  const btnRefs = useRef([]);
  const [pill, setPill] = useState({ left: 0, width: 0, height: 0 });

  // Mapear tu selectedIndex (1: todos, 3: mujeres, 2: hombres) -> índice 0/1/2
  const activeIdx = useMemo(() => {
    if (props.selectedIndex === 1) return 0; // Todxs
    if (props.selectedIndex === 3) return 1; // Mujeres
    if (props.selectedIndex === 2) return 2; // Hombres
    return 0;
  }, [props.selectedIndex]);

  // Recalcular posición/ancho del "pill" cuando cambia selección o al hacer resize
  useEffect(() => {
    const update = () => {
      const container = containerRef.current;
      const btn = btnRefs.current[activeIdx];
      if (!container || !btn) return;
      const c = container.getBoundingClientRect();
      const b = btn.getBoundingClientRect();
      setPill({
        left: b.left - c.left,
        width: b.width,
        height: b.height
      });
    };
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, [activeIdx]);

  return (
    <div className="flex justify-center mb-4 mt-2">
      <div
        ref={containerRef}
        className="relative flex items-center gap-3 rounded-xl ring-1 ring-white/10 px-2 py-1"
      >
        {/* Píldora roja animada detrás del botón activo */}
        <span
          aria-hidden
          className="absolute rounded-md bg-ccnorte transition-all duration-300 ease-out"
          style={{
            left: pill.left,
            width: pill.width,
            height: pill.height
          }}
        />

        {/* Botones (siempre transparentes, texto cambia) */}
        <button
          ref={(el) => (btnRefs.current[0] = el)}
          onClick={props.toggleSexoTodos}
          className={[
            'relative z-10 px-5 py-2 rounded-md font-montserrat text-xs uppercase tracking-wide',
            'cursor-pointer transition-colors duration-200',
            activeIdx === 0 ? 'text-white' : 'text-white hover:text-gray-400'
          ].join(' ')}
        >
          Todxs
        </button>

        <button
          ref={(el) => (btnRefs.current[1] = el)}
          onClick={props.toogleSexoFemenino}
          className={[
            'relative z-10 px-5 py-2 rounded-md font-montserrat text-xs uppercase tracking-wide',
            'cursor-pointer transition-colors duration-200',
            activeIdx === 1 ? 'text-white' : 'text-white hover:text-gray-400'
          ].join(' ')}
        >
          Mujeres
        </button>

        <button
          ref={(el) => (btnRefs.current[2] = el)}
          onClick={props.toogleSexoMasculino}
          className={[
            'relative z-10 px-5 py-2 rounded-md font-montserrat text-xs uppercase tracking-wide',
            'cursor-pointer transition-colors duration-200',
            activeIdx === 2 ? 'text-white' : 'text-white hover:text-gray-400'
          ].join(' ')}
        >
          Hombres
        </button>
      </div>
    </div>
  );
};

export default GeneroSelector;
